// sweetalertHelper.js
import Swal from 'sweetalert2';

export const showLoadingAlert = (title, text) => {
    Swal.fire({
        title: title,
        text: text,
        icon: 'info',
        allowOutsideClick: false,
        onBeforeOpen: () => {
            Swal.showLoading();
        },
    });
};

export const showSuccessAlert = (title, text) => {
    Swal.fire({
        title: title,
        text: text,
        icon: 'success',
        confirmButtonText: 'OK'
    });
};

export const showErrorAlert = (title, text) => {
    Swal.fire({
        title: title,
        text: text,
        icon: 'error',
        confirmButtonText: 'OK'
    });
};

// navigate parametresi dışarıdan alınacak
export const showSuccessAlertWithRedirect = (title, text, redirectUrl, buttonText = 'OK', navigate) => {
    Swal.fire({
        title: title,
        text: text,
        icon: 'success',
        confirmButtonText: buttonText,
    }).then((result) => {
        if (result.isConfirmed && navigate) {
            navigate(redirectUrl);
        }
    });
};
